<!-- eslint-disable vue/no-deprecated-slot-scope-attribute -->
<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <!-- Card header -->
          <div class="pb-0 card-header">
            <div class="d-lg-flex">
              <div>
                <h5 class="mb-0">All Invoices</h5>
                <p class="mb-0 text-sm">
                  Below the list of invoices.
                </p>
              </div>
              <div class="my-auto mt-4 ms-auto mt-lg-0">
                <div class="row">
                  <div class="col">
                    <div class="my-auto ms-auto">
                      <button
                      class="mt-1 mb-0 btn btn-outline-success btn-sm export mt-sm-0"
                      :class="{'disabled': exportLoading}"
                      @click="onClickExport()"
                    >
                      Export <i v-if="exportLoading" class="fas fa-spinner fa-pulse"></i>
                    </button>
                    
                    <download-excel
                      ref="btnExport"
                      class="mt-1 mb-0 btn btn-outline-success btn-sm export mt-sm-0 d-none"
                      :data="recordsForExport"
                      :fields="json_fields"
                      worksheet="My Worksheet"
                      name="invoices.xls"
                    >
                      Export
                    </download-excel>
                  </div>
                </div>                
                </div>                
              </div>
            </div>
            
          </div>
          <div class="px-0 pb-0 card-body">
            <div class="table-responsive">
              <div class="dataTable-wrapper dataTable-loading no-footer sortable searchable fixed-columns search-results">
                <div class="dataTable-top">
                  <div class="dataTable-dropdown">
                    <label>
                      <select class="dataTable-selector form-select form-select-sm" v-model="limitPerPage" @change="getAllAPI()">
                        <option v-for="item in perPages" :value="item" :key="item" >{{ item }}</option>                        
                      </select>
                      entries per page
                    </label>
                    </div>
                    <div class="dataTable-search">
                      <div class="row">
                        <div class="col-5">
                          <div class="input-daterange datepicker row align-items-center" >
                            <base-input addon-left-icon="ni ni-calendar-grid-58" >
                            <date-range-picker
                                ref="picker"
                                :opens="opts.opens"
                                :locale-data="{ firstDay: 1, format: 'dd-mm-yyyy' }"
                                :singleDatePicker="opts.singleDatePicker"
                                :showWeekNumbers="opts.showWeekNumbers"
                                :showDropdowns="opts.showDropdowns"
                                :autoApply="opts.autoApply"
                                :dateRange="opts.dateRange"
                                v-model="dates.range"
                                :linkedCalendars="opts.linkedCalendars"
                              >
                                <template v-slot:input="picker" style="min-width: 350px;">
                                    {{ dateTime(picker.startDate) }} - {{ dateTime(picker.endDate) }}
                                </template>
                              </date-range-picker>
                            </base-input>
                          </div>
                      
                        </div>
                        <div class="col-2">
                          <select class="dataTable-selector form-select form-select-sm" v-model="filter_by">
                            <option value="" disabled hidden>Search By</option>
                            <option v-for="item in filterOpts" :value="item.value" :key="item.label" >{{ item.label }}</option>                        
                          </select>          
                        </div>
                        <div class="col-3">
                          <input class="dataTable-input form-control" placeholder="Search..." type="text" v-model="search">
                        </div>
                        <div class="col">                                          
                          <button class="rounded btn btn-xs text-white bg-success" @click="getAllAPI()">
                            <i class="fa fa-search"></i>
                          </button>
                        </div>
                      </div>
                      
                    </div>
                  </div>
                  <div class="dataTable-container">
                    <table id="products-list" class="table table-flush dataTable-table">
                      <thead class="thead-light">
                        <tr>
                          <th>
                            No. 
                          </th>
                          <th>
                            Invoice ID
                          </th>
                          <th>
                            Invoice Title
                          </th>
                          <th>
                            Product Type
                          </th>
                          <th>
                            Subscription ID
                          </th>
                          <th>
                            Payment Type
                          </th>
                          <th>
                            Customer Code
                          </th>
                          <th>
                            Customer Name
                          </th>
                          <th>
                            Total Amount
                          </th>
                          <th>
                            Status
                          </th>
                          <th>
                            Transaction Date
                          </th>
                          <th>
                            Action
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(record, index) in records" :key="record.id">
                          <td class="text-sm">{{ ((this.currentPage-1)*this.limitPerPage) + index+1 }}</td>
                          <td class="text-sm">{{ record.id }} <p class="text-xs text-primary mb-0">{{ record.display_invoice_id }}</p></td>
                          <td class="text-sm">{{ record.order_title }}</td>
                          <td class="text-sm">{{ record.order_product_type }}</td>
                          <td class="text-sm">{{ record.subscription_id }}</td>
                          <td class="text-sm">{{ record.payment_type || '-' }}</td>
                          <td class="text-sm">{{ record.customer_code }}</td>
                          <td class="text-sm">{{ record.customer_name }}</td>
                          <td class="text-sm">Rp{{ record.payment_amount || 0 }}</td>
                          <td>
                            <span class="badge badge-danger badge-sm" v-if="record.status == 'declined'">Declined</span>
                            <span class="badge badge-danger badge-sm" v-else-if="record.status == 'expired'">Expired</span>
                            <span class="badge badge-info badge-sm" v-else-if="record.status == 'pending'">Pending</span>
                            <span class="badge badge-warning badge-sm" v-else-if="record.status == 'waiting_confirmation'">Waiting Confirmation</span>
                            <span class="badge badge-success badge-sm" v-else-if="record.status == 'paid'">Paid</span>
                          </td>
                          <td class="text-sm">{{ dateTime(record.created_at) }}</td>

                          <td class="text-sm">
                            <router-link
                              :to="{ 
                                path: '/invoices/'+ record.id +'/edit',
                                query: $route.query  // <- meneruskan query dari route sekarang
                              }"
                              class="mx-3"
                            >
                              <i class="fas fa-user-edit text-secondary" aria-hidden="true"></i>
                            </router-link>
                            <a v-if="record.status == 'paid'" :href="`/invoices/${record.id}/file`" class="mx-3" data-bs-toggle="tooltip" data-bs-original-title="File invoice">
                              <i class="fas fa-file-invoice text-secondary" aria-hidden="true"></i>
                            </a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="dataTable-bottom">
                    <div class="dataTable-info">Showing {{ totalRecords == 0 ? 0 : currentPage }} to {{ shownData() }} of {{  totalRecords }} entries</div>
                      <nav class="dataTable-pagination">
                        <argon-pagination color="success" size="sm">
                          <argon-pagination-item prev v-if="currentPage > 1" @click="onChangePagination(currentPage-1)"/>
                          <argon-pagination-item v-for="item in dataPerPages()" :label="String(item)" :active="item == currentPage" :key="item" @click="onChangePagination(item)"/>
                          <argon-pagination-item next v-if="currentPage < dataPerPages()" @click="onChangePagination(currentPage+1)"/>
                        </argon-pagination>
                      </nav>
                    </div>
                 
                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
<style>
  .vue-daterange-picker .form-control.reportrange-text{
    padding: 0.5rem 0.75rem !important;    
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
    border: 1px solid #ccc !important;
  }
  .vue-daterange-picker {
    width: 85%;
  }
  .input-daterange.datepicker .form-group.input-group {
    margin-right:50px;
  }
</style>
<script>
  import InvoiceService from "@/services/invoices.service.js";
  import ArgonPagination from "@/components/ArgonPagination.vue";
  import ArgonPaginationItem from "@/components/ArgonPaginationItem.vue";
  import BaseInput from "@/components/BaseInput.vue";
  import showSwalConfirmationDelete from "@/mixins/showSwal.js";
  import { ref } from 'vue';
  import { toast } from 'vue3-toastify';
  import JsonExcel from "vue-json-excel3";
  import DateRangePicker from 'vue3-daterange-picker'
  import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
  //you need to import the CSS manually


  const toastId = ref('');

  const moment = require('moment');

  export default {
    name: "ExternalUserList",
    data() {
      var startDate = new Date();
      var endDate = new Date();
      const queryParam = this.$route.query
      
      if(queryParam.date_start != undefined && queryParam.date_start != "") {
        startDate = moment(queryParam.date_start, "YYYY-MM-DD").toDate()        
      }else{
        startDate.setDate(startDate.getDate() - 7)
      }

      if(queryParam.date_end != undefined && queryParam.date_end != "") {
        endDate = moment(queryParam.date_end, "YYYY-MM-DD").toDate()        
      }
      
      return {
        filterOpts: [{label: 'Invoice', value: 'id'}, {label: 'Customer Code', value: 'customer_code'}, {label: 'Product Type', value:'order_product_type'},{label:'Subscription ID', value:'subscription_id'}],

        opts: {
          dateRange: {startDate,endDate},
          opens: "left",
          minDate: new Date(),
          maxDate: new Date(),
          singleDatePicker: false,
          showWeekNumbers: true,
          autoApply: false,
          linkedCalendars: true,
        },
        dates: {
            range: {startDate: startDate, endDate: endDate}
          },
        perPages: [5, 10, 15, 20, 25],
        records: [],
        totalRecords: 0,        
        limitPerPage: 5,
        currentPage: 1,
        search: '',
        filter_by: '',
        sortBy: {
          name: 'created_at',
          sortType: '-1'
        },
        json_fields: {
            "ID": "id",
            "Order Title": "order_title",
            "Product Type": "order_product_type",
            "Subscription ID": "subscription_id",
            "Customer Code": "customer_code",
            "Customer Name": "customer_name",
            "Total Amount": "payment_amount",
            "Status": "status",
            "Updated At": "updated_at",            
        },
        recordsForExport: [],
        exportLoading: false  
      };
    },
    mixins: [showSwalConfirmationDelete],
    methods: {
      onClickExport(){
        this.exportLoading = true
        this.showLoading()

        const params = {
          limit: 1000,
          page: 1,
          filter: this.search,
          filter_by: this.filter_by,
          date_start: this.dateTimeV2(this.dates.range.startDate),
          date_end: this.dateTimeV2(this.dates.range.endDate)
        }
        params[`sort_by[${this.sortBy.name}]`] = `${this.sortBy.sortType}`

        InvoiceService.getAll(params).then(e => {
          this.hideLoading()
          this.exportLoading = false

          const data = e.data
          this.recordsForExport = data.invoices
          if(this.recordsForExport != null && this.recordsForExport.length > 0 ){
            this.$refs.btnExport.$el.click()
          }

        })
      },
      showLoading(){
        toastId.value = toast.loading('Please wait...');
      },
      hideLoading(){
        setTimeout(() => {
          toast.remove(toastId.value)
        }, 1000); 
      },
      showSuccess(){
        toast.update(toastId.value, {
          render: "delete Successfully",
          closeOnClick: true,
          closeButton: true,
          type: 'success',
          isLoading: false,
          autoClose: 3000
        });      
      },
      showFailed(e){
        toast.update(toastId.value, {
          render: e,
          closeOnClick: true,
          closeButton: true,
          type: 'error',
          isLoading: false,
          autoClose: 3000
        });
      },
      confirmationDelete(id){
        this.showSwalConfirmationDelete().then((result) => {
            console.log(result)
            if (result.value) {
              this.deleteRecord(id)
            }
          });        
      },
      deleteRecord(id){
        this.showLoading()

        InvoiceService.delete(id).then(() => {
          this.showSuccess()
          this.getAllAPI()
        }).catch(e => {
          this.showFailed(e.response.data.code_message)           
        });
      },
      dateTime(value) {
        return moment(value).format("DD MMM YYYY");
      },
      dateTimeV2(value) {
        return moment(value).format("YYYY-MM-DD");
      },
      shownData() {
        const total = this.limitPerPage*this.currentPage
        return this.totalRecords > total ? total : this.totalRecords
      },
      dataPerPages() {
        const total = Math.ceil(this.totalRecords / this.limitPerPage)
        return total
      },
      onChangePagination(event) {
        this.currentPage = event
        this.getAllAPI()
      },
      getAllAPI(){
        // console.log(this.dates)
        const params = {
          limit: this.limitPerPage,
          page: this.currentPage,
          filter: this.search,
          filter_by: this.filter_by,
          date_start: this.dateTimeV2(this.dates.range.startDate),
          date_end: this.dateTimeV2(this.dates.range.endDate)
        }
        params[`sort_by[${this.sortBy.name}]`] = `${this.sortBy.sortType}`

        InvoiceService.getAll(params).then(e => {
          const data = e.data
          this.records = data.invoices
          this.totalRecords = data.count
        })

        // Update query params di route agar bisa diingat
        this.$router.replace({
          path: '/invoices',     // sesuaikan path Anda
          query: {
            search: this.search,
            filter_by: this.filter_by,
            limitPerPage: this.limitPerPage,
            currentPage: this.currentPage,
            date_start: this.dateTimeV2(this.dates.range.startDate),
            date_end: this.dateTimeV2(this.dates.range.endDate),
            sortByName: this.sortBy.name,
            sortByType: this.sortBy.sortType
          }
        })
      },      
    },
    components: {
      ArgonPagination,
      ArgonPaginationItem,
      BaseInput,
      DateRangePicker,
      downloadExcel:JsonExcel

    },
    mounted() {
      const { query } = this.$route

      // jika ada query search, restore
      if(query.search){
        this.search = query.search
      }
      if(query.filter_by){
        this.filter_by = query.filter_by
      }
      if(query.limitPerPage){
        this.limitPerPage = parseInt(query.limitPerPage, 10)
      }
      if(query.currentPage){
        this.currentPage = parseInt(query.currentPage, 10)
      }
      if(query.sortByName && query.sortByType){
        this.sortBy.name = query.sortByName
        this.sortBy.sortType = query.sortByType
      }
      // date_start & date_end
      // if(query.date_start && query.date_end){
      //   // parse string ke Date
      //   const start = moment(query.date_start, "YYYY-MM-DD").toDate()
      //   const end = moment(query.date_end, "YYYY-MM-DD").toDate()
      //   this.dates.range.startDate = start
      //   this.dates.range.endDate = end
      // }

      this.getAllAPI()
    },
  };
  </script>
  